import React, { useState, useEffect} from "react";
import axios from 'axios'

import {
  StyledContainer,
  StyledInnerContainer,
  StyledHeaderContainer,
  StyledInputContainer,
  StyledInputContainerFull,
  StyledButtonContainer,
  StyledDescriptionList,
  StyledDescriptionListItem,
  StyledMessage
} from "./ContactUsStyle";
import MainInput from "../../../components/MainInput/MainInput";
import MainTextarea from "../../../components/MainTextarea/MainTextarea";

import RadiusedButton from "../../../components/RadiusedButton";
import { useTranslation } from "react-i18next";
import ComponentTitle from "../../../components/ComponentTitle/ComponentTitle";

const KVALIFIKA_AUTHORIZATION_KEY =
  "1595506332PvmFL73KMelOIkpfZNvB1bx6nM4Htc0t506zFFC3"
  
const ContactUs = () => {
  const { t } = useTranslation();
  const [serverState, setServerState] = useState({
    submitting: false,
    status: null,
    emptyField: "",
  })

  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: "",
  })

  const isStatusOK = serverState.status && serverState.status.ok

  useEffect(() => {
    if (serverState.emptyField !== "") {
      setTimeout(() => {
        setServerState({ emptyField: "" })
      }, 4000)
    }
  }, [serverState.emptyField])

  useEffect(() => {
    if (isStatusOK) {
      setTimeout(() => {
        setServerState({ status: null })
      }, 10000)
    }
  }, [isStatusOK])

  const handleInputChange = e => {
    const { name, value } = e.target
    setForm({ ...form, [name]: value })
  }

  const handleServerResponse = ok => {
    setServerState({
      submitting: false,
      status: { ok },
    })
    if (ok) {
      setForm({
        fullName: "",
        email: "",
        phone: "",
        message: "",
      })
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()

    const isOneOfThemEmpty = Object.entries(form).some(([key, value]) => {
      if (value === "") {
        setServerState({ emptyField: key })
      }
      return value === ""
    })

    if (isOneOfThemEmpty) return

    try {
      setServerState({ submitting: true })
      const res = await axios({
        method: "post",
        headers: { Authorization: KVALIFIKA_AUTHORIZATION_KEY },
        url: "https://apidev.kvalifika.ge/forms",
        data: form,
      })

      if (res.data) {
        handleServerResponse(true)
      }
    } catch (err) {
      handleServerResponse(false)
    }
  }


  return (
    <StyledContainer id="contact">
      <StyledHeaderContainer>
        <ComponentTitle start value={"contactUs"} />
        <StyledDescriptionList>
          <StyledDescriptionListItem>
            {t("gotAnyQuestion")}
          </StyledDescriptionListItem>
          <StyledDescriptionListItem>
            {t("dontHesitateToReachOut")}
          </StyledDescriptionListItem>
          <StyledDescriptionListItem>
            {t("pleaseFillInBelow")}
          </StyledDescriptionListItem>
          {/* <StyledDescriptionListItem>
            {t("phoneNumber")}
          </StyledDescriptionListItem> */}
        </StyledDescriptionList>
      </StyledHeaderContainer>
      <StyledInnerContainer>
        <StyledInputContainer>
          <MainInput 
            placeholder="fullName"
            onChange={handleInputChange}
            value={form.fullName}
            name="fullName"
          />
        </StyledInputContainer>
        <StyledInputContainer>
          <MainInput 
            placeholder="emailAddress"
            onChange={handleInputChange}
            value={form.email}
            name="email"
          />
          <MainInput 
            placeholder="phone"
            onChange={handleInputChange}
            value={form.phone}
            name="phone"
          />
        </StyledInputContainer>
        <StyledInputContainerFull marginTop={""}>
          <MainTextarea
            placeholder="Your message"
            onChange={handleInputChange}
            value={form.message}
            name="message"
          />
        </StyledInputContainerFull>
        {serverState.emptyField && serverState.emptyField !== "" && (
          <StyledMessage>
            {`Please enter your ${serverState.emptyField}`}
          </StyledMessage>
        )}
        {isStatusOK && (
          <StyledMessage success> Your message successfully sent! </StyledMessage>
        )}
        <StyledButtonContainer>
          <RadiusedButton 
            onClick={handleSubmit}
            value={serverState.submitting ? "Loading" : "sendMessage"}
          />
        </StyledButtonContainer>
      </StyledInnerContainer>
    </StyledContainer>
  );
};

export default ContactUs;
